// Package Imports
import React from 'react';

// Style Imports 
import styles from './cartCheckoutDisclosures.module.scss';

export default function CartCheckoutDisclosures() {
  return (
    <section className={styles.cartCheckoutDisclosures}>
      <p>
        Your personal data will be used to process your order, support your experience throughout this website,
        and for other purposes described in our <a href='/legal/privacy-policy/' target='_blank'>privacy policy</a>.
      </p>
    </section>
  );
}
